import styled from "styled-components";
import fipayFonts from "../../../../theme/index";
import { colors } from "../../../../theme/color";

// Feature 1 textstyles

export const TitleHolder = styled.div`
  height: 112px;
  padding-top: 60px;
  padding-left: 30px;
  @media screen and (max-width: 768px) {
    height: 68px;
  }
  @media screen and (max-width: 375px) {
    height: 64px;
  }
`;

export const SubtitleHolder = styled.div`
  width: 504px;
  height: 64px;
  padding-left: 30px;

  @media screen and (max-width: 2560px) {
    width: 604;
  }

  @media screen and (max-width: 1024px) {
    width: 448px;
    height: 72px;
    margin-top: 10px;
  }
  @media screen and (max-width: 768px) {
    width: 448px;
    height: 72px;
    margin-top: 20px;
  }
  @media screen and (max-width: 430px) {
    width: 300px;
    height: 72px;
  }
  @media screen and (max-width: 375px) {
    width: 295px;
    height: 72px;
  }
  @media screen and (max-width: 320px) {
    width: 255px;
    height: 72px;
  }
`;

export const TitleText = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: ${fipayFonts.fipayFonts.heading1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.BLACK};

  /* @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    /* line-height: ${fipayFonts.fipayFonts.lineHeight.heading3}; */
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    /* line-height: ${fipayFonts.fipayFonts.lineHeight.heading3}; */
    /* text-align: left; */
  }
`;

export const SubtitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 2560px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
  }

  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};

    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
`;
